import { useEffect } from "react";

export function useScrollToTop() {
  function scrollToTop(behavior = "smooth") {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior,
    });
  }

  useEffect(() => {
    scrollToTop();
  }, []);

  return { scrollToTop };
}
